import Grid from '@mui/material/Unstable_Grid2/Grid2';
import CopyableContent from 'components/atoms/CopyableContent';
import PropTypes from 'prop-types';
import React from 'react';

const DisplayWebhook = ({ webhook: { webhookSecret, webhookUrl } }) => {
  return (
    <Grid container>
      <Grid lg={6}>
        <CopyableContent
          message="Copiar WEBHOOK URL"
          contentToCopy={webhookUrl}
        />
      </Grid>
      <Grid lg={6}>
        <CopyableContent
          message="Copiar WEBHOOK SECRET"
          contentToCopy={webhookSecret}
        />
      </Grid>
    </Grid>
  );
};

DisplayWebhook.propTypes = {
  webhook: PropTypes.shape({
    webhookUrl: PropTypes.string,
    webhookSecret: PropTypes.string
  })
};

export default DisplayWebhook;
